export const CarDetailRules = {
  /*  companyType: [
        { required: true, message: '请输入保险公司', trigger: 'blur' },
    ],*/
    // winningCompanyCode: [
    //     { required: true, message: '请输入中标商编码', trigger: 'blur' },
    // ],
    // claimNumber: [
    //     { required: true, message: '请输入报案号', trigger: 'blur' },
    // ],
 /*   lossofstaffname: [
        { required: true, message: '请输入查勘员姓名', trigger: 'blur' },
    ],
    vehiclenumber: [
        { required: true, message: '请输入询价号', trigger: 'blur' },
        // 只允许输入数字或者字母
        { pattern: /^[A-Za-z0-9]+$/, message: "请输入正确的询价编号", trigger: 'blur' },
    ],*/
    // lossofstaffphone: [
    //     { required: true, message: '请输入查勘员电话', trigger: 'blur' },
    //     // 电话号
    //     { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号", trigger: 'blur' },
    // ],
/*    insuranceamount: [
        { required: true, message: '请输入保险金额', trigger: 'blur' },
        { pattern: /^[0-9]+([.]{1}[0-9]{1,2})?$/, message: "请输入数字", trigger: 'blur' },
        { pattern: /^.{0,7}$/, message: "只允许输入7位数字", trigger: 'blur' },
    ],*/
/*    vehicletemporary: [
        { required: true, message: '请输入车停放地', trigger: 'blur' },
    ],*/
/*    practicalvalue: [
        { required: true, message: '请输入实际价值', trigger: 'blur' },
        { pattern: /^[0-9]+([.]{1}[0-9]{1,2})?$/, message: "请输入数字", trigger: 'blur' },
        { pattern: /^.{0,7}$/, message: "只允许输入7位数字", trigger: 'blur' },
    ],*/
    auctionstarttime: [
        { required: true, message: '请选择询价开始时间', trigger: 'blur' },
    ],

    auctionendtime: [
        { required: true, message: '请选择询价截止时间', trigger: 'blur' },
    ],

/*    amountofestimatedloss: [
        { required: true, message: '请输入预估损失', trigger: 'blur' },

        { pattern: /^[0-9]+([.]{1}[0-9]{1,2})?$/, message: "请输入数字", trigger: 'blur' },
        { pattern: /^.{0,7}$/, message: "只允许输入7位数字", trigger: 'blur' },
    ],*/

    otherexpenses: [
        { required: true, message: '请输入其他费用', trigger: 'blur' },
        { pattern: /^[0-9]+([.]{1}[0-9]{1,2})?$/, message: "请输入数字", trigger: 'blur' },
        { pattern: /^.{0,7}$/, message: "只允许输入7位数字", trigger: 'blur' },
    ],
    isSecondPrice: [
        { required: true, message: '请选择二次询价', trigger: 'change' },
    ],



    // 车辆信息
/*    licenseplate: [
        { required: true, message: '请输入车牌号', trigger: 'blur' },
        // { pattern: /^.{7}$/, message: "请输入正确的车牌号", trigger: 'blur' },
    ],*/
 /*   dangertime: [
        { required: true, message: '请选择出险时间', trigger: 'blur' },
    ],*/
/*    vehiclemodel: [
        { required: true, message: '请输入品牌', trigger: 'blur' },
    ],*/
/*    vehicledamagecause: [
        { required: true, message: '请选择事故类型', trigger: 'change' },
    ],*/
/*    models: [
        { required: true, message: '请输入车型', trigger: 'blur' },
    ],*/
    isDisassembly: [
        { required: true, message: '请选择是否拆解', trigger: 'change' },
    ],
/*    dateofregistration: [
        { required: true, message: '请选择初登日期', trigger: 'blur' },
    ],*/
    useproperty: [
        { required: true, message: '请输入使用性质', trigger: 'blur' },
    ],

    ownernature: [
        { required: true, message: '请输入车辆所属人', trigger: 'blur' },
    ],

   /* vehicleidentificationnumber: [
        { required: true, message: '请输入车架号', trigger: 'blur' },
        // 英文和数字
        { pattern: /^[A-Za-z0-9]+$/, message: "请输入正确的车架号", trigger: 'blur' },
    ],
    framenumberisdamaged: [
        { required: true, message: '请选择车架号损坏', trigger: 'change' },
    ],
    gearboxtype: [
        { required: true, message: '请输入变速箱类型', trigger: 'change' },
    ],
    isTransmissionDamaged: [
        { required: true, message: '请选择变速箱损坏', trigger: 'change' },
    ],
    enginenumber: [
        { required: true, message: '请输入发动机号', trigger: 'blur' },
    ],
    isEngineDamaged: [
        { required: true, message: '请选择发动机损坏', trigger: 'change' },
    ],*/
    IsTransfers: [
        { required: true, message: '请输入选择是否过户', trigger: 'change' },
    ],

    ifaccident: [
        { required: true, message: '请选择二次事故', trigger: 'change' },
    ],
 /*   outputvolume: [
        { required: true, message: '请输入排量', trigger: 'blur' },
    ]*/

}
